import type { StepType } from "@reactour/tour";
import { text } from "@quickpoint.me/shared";
import TourStepContent from "./wrapper";
import { switchToLevel } from "./helpers";

const whatNext: StepType[] = [
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => <strong>{text.tourSteps.yourWorkflow}</strong>}
			/>
		),
		position: "center",
	},
	{
		selector: "#tab-chat",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						<strong>{text.tourSteps.startWithChat}</strong>
					</span>
				)}
			/>
		),
		action: () => {
			switchToLevel(1);
		},
	},
	{
		selector: "#tab-edit-element",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						<strong>{text.tourSteps.useEditElement}</strong>
					</span>
				)}
			/>
		),
	},
	{
		selector: "#tab-structure",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						<strong>{text.tourSteps.masterStructure}</strong>
					</span>
				)}
			/>
		),
	},
	{
		selector: "#control-stories",
		content: () => (
			<TourStepContent
				description={() => text.tourSteps.storiesSaved}
			/>
		),
	},
	{
		selector: "#action-control-publish",
		content: () => (
			<TourStepContent
				description={() => text.tourSteps.clickPublish}
			/>
		),
	},
	{
		selector: "#action-control-qr",
		content: () => (
			<TourStepContent
				description={() => text.tourSteps.shareWithLink}
			/>
		),
	},
	{
		selector: ".tour",
		content: () => (
			<TourStepContent
				description={() => text.tourSteps.clickTour}
			/>
		),
	},
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.readyToGo}
						<br />
						<br />
						{text.tourSteps.startByTyping}
					</span>
				)}
			/>
		),
		position: "center",
		action: () => {
			switchToLevel(1);
		},
	},
];

export default whatNext;
